// import yiDunSdkJs from './YiDunProtector-Web';
// const { createNEGuardian } = require('./YiDunProtector-Web');
// import './YiDunProtector-Web';
import { apiRiskCheck } from './service';
const sdk = {
  yiDunProtector: i => {
    try {
      const neg = window.createNEGuardian({ productId: 'YD00230539366651', timeout: 6000 });
      neg.getToken().then(result => {
        if (result.code === 200) {
          // 正常情况
          sdk.getInit(result.token, i);
          console.log('get token:', result.token);
        }
        if (result.code === 201) {
          // 离线模式
          console.log('offLine token:', result.token);
        }
      });
    } catch (error) {
      console.log('error:', error);
    }
  },
  getInit: async (str, i) => {
    await apiRiskCheck({
      wy_token: str,
      scene: i
    });
  }
};

export default sdk;
